export const tags = ['research', 'News', 'Article', 'Event', 'Promo'];
